module.exports = __webpack_public_path__ + "img/icon1.cc5679da.png";